import { Component } from "@angular/core";
import { ICellRendererAngularComp } from "ag-grid-angular";
import { ICellRendererParams } from "ag-grid-community";

@Component({
  selector: "ag-grid-evrideo-checkbox-cell",
  template: `<mat-checkbox
    [checked]="params?.node?.isSelected()"
    (change)="toggleSelect($event.checked)"
    [color]="'primary'"
  ></mat-checkbox>`,
  styleUrls: ["./ag-grid-evrideo-checkbox-cell.component.scss"],
})
export class AgGridEvrideoCheckboxCellComponent
  implements ICellRendererAngularComp
{
  params: any;
  isChecked: boolean = false;

  agInit(params: ICellRendererParams): void {
    this.updateDisplayValue(params);
  }

  refresh(params: ICellRendererParams): boolean {
    this.updateDisplayValue(params);
    return true;
  }

  private updateDisplayValue(params: ICellRendererParams): void {
    if (!params.node) {
      return;
    }
    this.params = params;
  }

  toggleSelect(checked) {
    if (this.params?.node) {
      this.params.node.setSelected(checked, false, "checkboxSelected");
    }
  }
}
